import {
  selectScreenName,
  selectStripeAccountId,
  selectStripeAccountName,
} from 'root-redux/selects/common'
import { selectUUID } from 'root-redux/selects/user'

import { createIntroOfferProductId } from 'helpers/createIntroOfferProductId'
import { createProductId } from 'helpers/createProductId'

import {
  selectCurrency,
  selectSubscriptionFullPrice,
  selectSubscriptionLookupKey,
  selectSubscriptionPeriodName,
  selectSubscriptionPeriodQuantity,
  selectSubscriptionTrialLookupKey,
  selectSubscriptionTrialPeriodDays,
  selectSubscriptionTrialPeriodPrice,
} from 'modules/purchase/redux/selects/common'

import { IAppState } from 'models/store.model'

export const getPurchaseCommonEventParams = (state: IAppState) => {
  const uuid = selectUUID(state)
  const stripePriceId = selectSubscriptionLookupKey(state)
  const trialPeriodPrice = selectSubscriptionTrialPeriodPrice(state)
  const trialPriceId = selectSubscriptionTrialLookupKey(state)
  const fullPrice = selectSubscriptionFullPrice(state)
  const trialPeriodQuantity = selectSubscriptionTrialPeriodDays(state)
  const periodName = selectSubscriptionPeriodName(state)
  const periodQuantity = selectSubscriptionPeriodQuantity(state)
  const currency = selectCurrency(state)
  const screenName = selectScreenName(state)
  const stripeAccountName = selectStripeAccountName(state)
  const stripeAccountId = selectStripeAccountId(state)

  const productId = trialPriceId
    ? createIntroOfferProductId({
        priceId: stripePriceId,
        trialPriceId,
        trialPeriodQuantity,
      })
    : createProductId({
        periodName,
        periodQuantity,
        price: fullPrice,
      })

  return {
    uuid,
    trialPriceId,
    trialPeriodPrice,
    periodName,
    periodQuantity,
    currency,
    screenName,
    productId,
    stripePriceId,
    stripeAccountName,
    fullPrice,
    stripeAccountId,
  }
}
